import React from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * FilterBarSkeleton - Skeleton placeholder for filter dropdowns
 *
 * Shows placeholder filter controls while ticker/filter data loads.
 *
 * @param {number} filterCount - Number of filter dropdowns to show (default: 3)
 * @param {boolean} showLabel - Whether to show label above filters (default: true)
 */
const FilterBarSkeleton = ({ filterCount = 3, showLabel = true }) => {
  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, alignItems: 'center' }}>
      {showLabel && (
        <Skeleton variant="text" width={80} height={24} sx={{ mr: 1 }} />
      )}
      {[...Array(filterCount)].map((_, i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          width={i === 0 ? 160 : 140}
          height={40}
          sx={{ borderRadius: 1 }}
        />
      ))}
    </Box>
  );
};

export default FilterBarSkeleton;
